import React from 'react';

const Picture = ({picture}) => (
	<div className="person-img wow fadeIn">
		<img src={picture} alt="" className="z-depth-1"/>
	</div>
);

export default Picture;



// WEBPACK FOOTER //
// ./src/components/elements/About/Picture.js